jQuery( function ( $ ) {

  // date picker for subscription start
  // $( 'form.cart' ).on( 'show_variation', function () {
  //   $( '.wcscsd_calendar_dates_field' ).addClass( 'form-control' );
  // });


  // // fixes intial value not being re-selectable in select2
  // const $variation_form = $( 'form.variations_form.cart' );
  // if ( $variation_form.length ) {
  //   $variation_form.on( 'check_variations', () => {
  //     $( 'select', $variation_form ).each( function () {
  //       ThemeJS.Functions.init_select2( this, true );
  //     });
  //   });
  // }

});